import { ActionType } from 'typesafe-actions';
import * as actions from './appConfigActions';
import {
    APP_INIT_SUCCESS,
    GET_APP_CONFIG_FAILURE,
    GET_APP_CONFIG_REQUEST,
    GET_APP_CONFIG_SUCCESS,
    SET_APP_VIEW,
} from './appConfigConstants';
import {
    AppView,
    HydratedCurriculumFinderConfig,
} from '../Common/types/AppConfigTypes';

export type AppConfigAction = ActionType<typeof actions>;

export type AppConfigState = Readonly<{
    isInitialized: boolean;
    isLoading: boolean;
    isError: boolean;
    config?: HydratedCurriculumFinderConfig;
    view: AppView;
}>;

export const initialState: AppConfigState = {
    isInitialized: false,
    isLoading: false,
    isError: false,
    view: AppView.List,
};

export default (
    state: AppConfigState = initialState,
    action: AppConfigAction,
) => {
    switch (action.type) {
        case GET_APP_CONFIG_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case GET_APP_CONFIG_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isError: false,
                config: action.payload,
            };
        case GET_APP_CONFIG_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case APP_INIT_SUCCESS:
            return {
                ...state,
                isInitialized: true,
            };
        case SET_APP_VIEW:
            return {
                ...state,
                view: action.payload,
            };
        default:
            return state;
    }
};
